import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Resolve stored image path (e.g. "/api/files/...") to a full URL
export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};

export const adminHeaders = () => {
  const t = localStorage.getItem("dakid_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};
